import { type ConnectOptions } from '@goshippo/print';

export const QZ_TRAY_CONNECT_OPTIONS: ConnectOptions = {
  delay: 1,
  keepAlive: 60,
  port: {
    insecure: [8186, 8287, 8388, 8489],
    secure: [8185, 8286, 8387, 8488],
  },
  retries: 0,
};
